/**
 * Constantes com os nomes exatos das permissões do sistema ERP Mobytech.
 * Esses nomes devem corresponder ao campo "Name" da tabela Permissions no banco de dados.
 *
 * Uso no template:
 *   <button *appHasPermission="Permissions.CUSTOMERS_CREATE">Criar Cliente</button>
 *
 * Uso no TypeScript (component):
 *   readonly Permissions = ERPPermissions;
 *   this.permissionService.hasPermission(ERPPermissions.CUSTOMERS_VIEW);
 *
 * Uso na rota:
 *   data: { requiredPermissions: [ERPPermissions.CUSTOMERS_VIEW] }
 */
export const ERPPermissions = {

  // ========================
  // COMMERCIAL
  // ========================
  CUSTOMERS_VIEW:             'Customers.View',
  CUSTOMERS_CREATE:           'Customers.Create',
  CUSTOMERS_EDIT:             'Customers.Edit',
  CUSTOMERS_DELETE:           'Customers.Delete',

  CONTRACTS_VIEW:             'Contracts.View',
  CONTRACTS_CREATE:           'Contracts.Create',
  CONTRACTS_EDIT:             'Contracts.Edit',
  CONTRACTS_RENEW:            'Contracts.Renew',
  CONTRACTS_REPLACE_VEHICLE:  'Contracts.ReplaceVehicle',

  VEHICLE_RENTALS_VIEW:       'VehicleRentals.View',
  VEHICLE_RENTALS_CREATE:     'VehicleRentals.Create',
  VEHICLE_RENTALS_EDIT:       'VehicleRentals.Edit',
  VEHICLE_RENTALS_APPROVE:    'VehicleRentals.Approve',

  APPOINTMENTS_VIEW:          'Appointments.View',

  // ========================
  // RECURSOS HUMANOS
  // ========================
  STAFF_VIEW:                 'Staff.View',
  STAFF_CREATE:               'Staff.Create',
  STAFF_EDIT:                 'Staff.Edit',
  STAFF_DELETE:               'Staff.Delete',

  DEPARTMENTS_VIEW:           'Departments.View',
  DEPARTMENTS_MANAGE:         'Departments.Manage',

  POSITIONS_VIEW:             'Positions.View',
  POSITIONS_MANAGE:           'Positions.Manage',

  PAYROLL_VIEW:               'Payroll.View',
  VISUALIZAR_SALARIO:         'VisualizarSalario',

  // ========================
  // VEÍCULOS
  // ========================
  VEHICLES_VIEW:              'Vehicles.View',
  VEHICLES_CREATE:            'Vehicles.Create',
  VEHICLES_EDIT:              'Vehicles.Edit',
  VEHICLES_DELETE:            'Vehicles.Delete',

  IPVA_LICENSING_VIEW:        'IpvaLicensing.View',

  // ========================
  // COMPRAS
  // ========================
  SUPPLIERS_VIEW:             'Suppliers.View',
  SUPPLIERS_CREATE:           'Suppliers.Create',
  SUPPLIERS_EDIT:             'Suppliers.Edit',

  PURCHASE_ORDERS_VIEW:       'PurchaseOrders.View',
  PURCHASE_ORDERS_CREATE:     'PurchaseOrders.Create',
  PURCHASE_ORDERS_EDIT:       'PurchaseOrders.Edit',
  PURCHASE_ORDERS_APPROVE:    'PurchaseOrders.Approve',

  /** Exibe o campo "% a mais" no orçamento B2B (oculto por padrão / treinamento). */
  BUDGET_CHARGE_PERCENT_VIEW: 'Budgets.ViewChargePercent',

  // ========================
  // FINANCEIRO
  // ========================
  ACCOUNTS_PAYABLE_VIEW:      'AccountsPayable.View',
  ACCOUNTS_PAYABLE_CREATE:    'AccountsPayable.Create',
  ACCOUNTS_PAYABLE_EDIT:      'AccountsPayable.Edit',
  ACCOUNTS_PAYABLE_APPROVE:   'AccountsPayable.Approve',

  ACCOUNTS_RECEIVABLE_VIEW:   'AccountsReceivable.View',
  ACCOUNTS_RECEIVABLE_CREATE: 'AccountsReceivable.Create',
  ACCOUNTS_RECEIVABLE_EDIT:   'AccountsReceivable.Edit',
  ACCOUNTS_RECEIVABLE_APPROVE:'AccountsReceivable.Approve',

  COST_CENTERS_VIEW:          'CostCenters.View',
  COST_CENTERS_MANAGE:        'CostCenters.Manage',

  BANK_STATEMENTS_VIEW:       'BankStatements.View',
  BANK_TRANSACTIONS_VIEW:     'BankTransactions.View',
  CASHFLOW_VIEW:              'Cashflow.View',

  TRAFFIC_FINES_VIEW:         'TrafficFines.View',
  TRAFFIC_FINES_MANAGE:       'TrafficFines.Manage',

  CARD_OPERATOR_VIEW:         'CardOperator.View',

  // ========================
  // DOCUMENTOS
  // ========================
  TEMPLATES_VIEW:             'Templates.View',
  TEMPLATES_CREATE:           'Templates.Create',
  TEMPLATES_EDIT:             'Templates.Edit',

  // ========================
  // PRODUTOS
  // ========================
  PRODUCTS_VIEW:              'Products.View',
  PRODUCTS_CREATE:            'Products.Create',
  PRODUCTS_EDIT:              'Products.Edit',
  PRODUCTS_DELETE:            'Products.Delete',

  // ========================
  // ESTOQUE
  // ========================
  WAREHOUSES_VIEW:            'Warehouses.View',
  WAREHOUSES_MANAGE:          'Warehouses.Manage',

  INVENTORY_VIEW:             'Inventory.View',
  INVENTORY_CREATE:           'Inventory.Create',
  INVENTORY_EDIT:             'Inventory.Edit',

  ITEMS_VIEW:                 'Items.View',
  ITEMS_CREATE:               'Items.Create',
  ITEMS_EDIT:                 'Items.Edit',

  STOCK_MOVEMENTS_VIEW:       'StockMovements.View',
  STOCK_MOVEMENTS_CREATE:     'StockMovements.Create',
  STOCK_MOVEMENTS_APPROVE:    'StockMovements.Approve',
  STOCK_MOVEMENTS_MANUAL_ENTRY: 'StockMovements.ManualEntry',
  STOCK_MOVEMENTS_MANUAL_EXIT:  'StockMovements.ManualExit',

  STOCK_ALERTS_VIEW:          'StockAlerts.View',

  // ========================
  // OPERAÇÕES
  // ========================
  SERVICES_VIEW:              'Services.View',
  SERVICES_CREATE:            'Services.Create',
  SERVICES_EDIT:              'Services.Edit',

  PREVENTIVE_MAINTENANCE_VIEW:   'PreventiveMaintenance.View',
  PREVENTIVE_MAINTENANCE_CREATE: 'PreventiveMaintenance.Create',
  PREVENTIVE_MAINTENANCE_EDIT:   'PreventiveMaintenance.Edit',

  CHECKLIST_VIEW:             'Checklist.View',
  CHECKLIST_CREATE:           'Checklist.Create',
  CHECKLIST_EDIT:             'Checklist.Edit',

  // ========================
  // B2B
  // ========================
  EXTERNAL_PROVIDERS_VIEW:    'ExternalProviders.View',
  EXTERNAL_PROVIDERS_CREATE:  'ExternalProviders.Create',
  EXTERNAL_PROVIDERS_EDIT:    'ExternalProviders.Edit',

  B2B_CONTRACTS_VIEW:         'B2BContracts.View',
  B2B_CONTRACTS_CREATE:       'B2BContracts.Create',
  B2B_CONTRACTS_EDIT:         'B2BContracts.Edit',

  // ========================
  // ADMINISTRATIVO
  // ========================
  USERS_VIEW:                 'Users.View',
  USERS_CREATE:               'Users.Create',
  USERS_EDIT:                 'Users.Edit',
  USERS_DELETE:               'Users.Delete',

  PROFILES_VIEW:              'Profiles.View',
  PROFILES_MANAGE:            'Profiles.Manage',

  GROUPS_VIEW:                'Groups.View',
  GROUPS_MANAGE:              'Groups.Manage',

  SCHEDULE_VIEW:              'Schedule.View',
  SCHEDULE_MANAGE:            'Schedule.Manage',

  // ========================
  // ORDENS DE SERVIÇO
  // ========================
  SERVICE_ORDERS_VIEW:        'ServiceOrders.View',
  SERVICE_ORDERS_CREATE:      'ServiceOrders.Create',
  SERVICE_ORDERS_EDIT:        'ServiceOrders.Edit',

  SERVICE_ORDERS_CONFIG_VIEW:   'ServiceOrdersConfig.View',
  SERVICE_ORDERS_CONFIG_MANAGE: 'ServiceOrdersConfig.Manage',

  // ========================
  // ACORDOS
  // ========================
  AGREEMENTS_VIEW:            'Agreements.View',
  AGREEMENTS_CREATE:          'Agreements.Create',
  AGREEMENTS_EDIT:            'Agreements.Edit',
  AGREEMENTS_CANCEL:          'Agreements.Cancel',

  // ========================
  // CONFIGURAÇÕES
  // ========================
  STATUS_VIEW:                'Status.View',
  STATUS_MANAGE:              'Status.Manage',

  SYSTEM_LOCK_VIEW:           'SystemLock.View',
  SYSTEM_LOCK_MANAGE:         'SystemLock.Manage',

} as const;

export type ERPPermission = typeof ERPPermissions[keyof typeof ERPPermissions];
